import { CampaignMessage } from '../models/CampaignMessage';
import {Message} from '../models/Message';

export function isCampaignMessage(item: Message | CampaignMessage): item is CampaignMessage {
  return (item as CampaignMessage).resolvedAt !== undefined;
}
